import { capitalize, numberToCurrency } from '@hc-frontend/utils'
import { getBenefitLabel } from 'core/controllerPlans/getBenefits'
import setMultiselectOptions from 'utils/DOM/setMultiselectOptions'

const globalFilters = [
  'benefits',
  'type',
  'networkProvider',
  'coverage',
  'deductible',
  'period'
]

function renderFilters(
  filterOptions: FilterOptions,
  filters,
  defaultPeriod,
  store,
  hiddenFilters?
) {
  globalFilters.forEach(name => {
    if (filterOptions[name]) {
      const { values, options } = filterOptions[name]
      const valuesToRender =
        hiddenFilters && hiddenFilters[name]
          ? values.filter(v => !hiddenFilters[name].find(f => f === v))
          : options || values

      const filterId = `filter--multiselect--${name}`

      let filterValues = filters[name]

      let formattedValues = {}
      if (name === 'period') {
        const policies = filters.policies || +store.hcStorage.policies || 1
        const filterPeriod = filters[name] || defaultPeriod
        valuesToRender.forEach(period => {
          const periodData = filterOptions[name].policies[period]
          for (let index = 1; index <= periodData.max; index++) {
            if (periodData[index]) {
              const label =
                periodData.extendedDuration === period
                  ? `${index > 1 ? `${index}x` : ''}${period}`
                  : `${period}${index > 1 ? `+${periodData.extendedDuration}` : ''}`

              formattedValues[`${index > 1 ? `${index}x` : ''}${period}`] = label
            }
          }

          const value =
            store.hcStorage.location.state_acronym === 'ND' && filterPeriod === 360
              ? '2x180'
              : `${policies > 1 ? `${policies}x` : ''}${filterPeriod}`

          filterValues = [value]
        })
      } else {
        formattedValues = valuesToRender.reduce((result, current) => {
          if (name === 'coinsurance') {
            result[current] = `${current}%`
          } else if (name === 'benefits') {
            result[current] = getBenefitLabel(current)
          } else if (name === 'coverage' || name === 'deductible') {
            result[current] = numberToCurrency(current)
            filterValues = filters[name].min ? [filters[name].min] : []
          } else if (name === 'networkProvider') {
            result[current] = capitalize(current)
          } else if (name === 'type') {
            // For sure_care, the standard capitalize function produces Sure Care
            // We want it to product SureCare, so in the case that we get sure_care, override with SureCare
            if (current === 'sure_care') {
              result[current] = 'SureCare'
            } else {
              result[current] = capitalize(current)
            }
          } else {
            result[current] = current.charAt(0).toUpperCase() + current.slice(1)
          }
          return result
        }, {})
      }

      setMultiselectOptions({
        options: formattedValues,
        parentId: filterId,
        cssClass: 'js-multiselect-option',
        values: filterValues,
        name
      })
    }
  })
}

export default renderFilters
